/// <amd-module name="Build/Admin/Common/Actions/SignalRActions" />
import { Action } from "VSS/Reflux/Action";

import { SignalRState } from "Build/Admin/Common/Stores/SignalRStore";

export class SignalRActions {
    public signalRStateUpdated = new Action<SignalRState>();
}
